import {
  AttributionDetails,
  BundleBasketFragment,
  OccupancyType,
} from '@generated/gql/graphql';
import { BundleBasketData } from '@src/types/bundle';

import { formatBroadband } from './broadband';
import { formatCashback } from './cashback';
import { hasExpiredBundle } from './hasExpiredBundle';
import { formatInsurance } from './insurance';

interface FormatBasketArgs {
  basket?: Nullable<BundleBasketFragment>;
  attributionDetails: Nullable<AttributionDetails>;
}

const formatBasket = ({
  basket,
  attributionDetails,
}: FormatBasketArgs): Nullable<BundleBasketData> => {
  if (!basket) {
    return null;
  }

  if (basket.quotes.length === 0) {
    // The API has historically returned responses without quotes
    throw new Error('parseBasket: quotes are missing in the response');
  }

  return {
    attributionDetails,
    basketStatus: basket.basketStatus,
    broadband: formatBroadband(basket),
    cashback: formatCashback(basket),
    createdAt: basket.details?.createdAt ?? '',
    depositRequired: basket.depositRequirement?.depositRequired ?? false,
    energy: basket.energy || null,
    hasExpiredBundle: hasExpiredBundle(basket),
    hasSmartmeter: basket.details.hasSmartmeter,
    id: basket.id,
    insurance: formatInsurance(basket),
    isHomeOwner: basket.details.occupancyType === OccupancyType.Homeowner,
    mobile: basket.mobile || null,
    monthlyCost: basket.monthlyCost,
    willCreditCheck: basket.willCreditCheck,
  };
};

export { formatBasket };
